import React from 'react'

import "./Contact.css"

import {ReactComponent as Mail} from '../assets/icons/mail.svg'
import {ReactComponent as Phone} from '../assets/icons/phone.svg'
import {ReactComponent as Fax} from '../assets/icons/fax.svg'

import Form from './Form/Form'
import { useTranslate } from '../Context/LanguageContext'

const Contact = () => {
    const t = useTranslate("contact")

    return (
        <div className='contact-page'>
            <div className='contact-container'>

                <section className='contact-info'>
                    <div className='contact-info-content'>
                        <h1>{t("title")}</h1>
                        <p className='subtitle'>{t("subtitle")}</p>

                        <div className='contact-details'>
                            <a className='detail' href='mailto:info@sinis.de'>
                                <span className='icon'><Mail/></span>
                                <span>info@sinis.de</span>
                            </a>
                            <a className='detail' href='tel:+4981028961688'>
                                <span className='icon'><Phone/></span>
                                <span>(+49) 8102 89616-88</span>
                            </a>
                            <a className='detail' href='fax:+4981028961699'>
                                <span className='icon'><Fax/></span>
                                <span>(+49) 8102 89616-99</span>
                            </a>
                        </div>

                        <div className='contact-address'>
                            <p>SINIS GmbH</p>
                            <p>Waldstr. 14</p>
                            <p>D-85635 Höhenkirchen</p>
                            <p>{t("germany")}</p>
                        </div>
                    </div>
                </section>

                <section className='contact-form'>
                    <Form/>
                </section>

            </div>
        </div>
    );
}

export default Contact;
